import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { HeadingLevel2, HeadingLevel4 } from '@yme/tokens/typography';
import { escapeImageUrl } from '@yme/utils/common';
import { getTextStyles } from '@yme/utils/styles';
export const CardWrapperStyled = styled.div `
  min-width: 100%;
  height: 500px;

  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
    url(${({ bgSrc }) => escapeImageUrl(bgSrc)}), rgba(0, 0, 0, 0.1);

  background-size: cover;
  background-position: 50%;

  &:not(:last-child) {
    margin-bottom: 16px;

    ${ADAPTIVE.minWidth.tablet} {
      margin-bottom: 24px;
    }
  }
`;
export const CardHeaderStyled = styled(HeadingLevel2) `
  margin: 4px 0 16px;
`;
export const SubTitleStyled = styled(HeadingLevel4) `
  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles(null, null, 14, 16)}
  }
`;
